import { useEffect } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

type Options = {
  disabled?: boolean;
  onDragStart?: () => void;
  onDrop?: () => void;
};

export function useDraggableCard(
  elementRef: React.RefObject<HTMLElement>,
  cardId: string,
  options: Options = {}
) {
  useEffect(() => {
    if (options.disabled || !elementRef.current) return;

    return draggable({
      element: elementRef.current,
      getInitialData: () => ({
        type: 'card',
        id: cardId,
      }),
      onDragStart: () => {
        options.onDragStart?.();
      },
      onDrop: () => {
        options.onDrop?.();
      },
    });
  }, [
    elementRef,
    cardId,
    options.disabled,
    options.onDragStart,
    options.onDrop,
  ]);
}
